import { render, staticRenderFns } from "./AddSupplierDetail.vue?vue&type=template&id=20b69a8a&"
import script from "./AddSupplierDetail.vue?vue&type=script&lang=js&"
export * from "./AddSupplierDetail.vue?vue&type=script&lang=js&"
import style0 from "./AddSupplierDetail.vue?vue&type=style&index=0&id=20b69a8a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports